const initialState = {
    cart: []
}

const CartReducer = (state = initialState, action) => {
    switch (action.type) {
        case "SET_CART":
            return { ...state,        
                cart: action.payload.cart }
            break;
        default:
            break;
    }

    return state;
}

export default CartReducer;